// src/utils/checkDineInExpiry.js
export const checkDineInExpiry = () => {
  const sessionData = localStorage.getItem("dinein");

  if (!sessionData) return null;

  const data = JSON.parse(sessionData);
  const now = Date.now();
  // console.log(data,"=====================");
  if (data.expiresAt && now > data.expiry) {
    // Expired — remove it
    localStorage.removeItem("dinein");
    return null;
  }

  return data; // still valid
};
